<script setup lang="ts">
import keycloak from '@/keycloak';
import { type State } from '@/store/store_types';
import { computed } from 'vue';
import { useStore } from 'vuex';

const store = useStore<State>()
const action = computed(() => store.state.returning_auth_action)

function handleLogin() {
  const redirectUri =
    window.location.origin +
    '/#/login/' +
    new URLSearchParams(
      'location=' +
        (window.location.hash.includes('location=')
          ? window.location.hash.replace(/&location=.*/, '')
          : window.location.hash) +
        '&' +
        (action.value ? 'action=' + action.value + '&' : '') +   
        window.location.search,
    ).toString()

  keycloak.login({
    redirectUri,
  })
}
</script>
<template>
  <a @click.stop="handleLogin" class="text-decoration-underline text-pwt_palatinate_blue">login</a>
</template>
